import { LAYER_TYPE } from '@tmapy/config';
export function getFeaturesFromLayer(layers, layerId) {
    const layer = layers.find((layer) => layer.type === LAYER_TYPE.VECTOR && layer.id === layerId);
    return layer?.features ?? [];
}
export function getFeatureFromLayer(layers, layerId, featureId) {
    const feature = getFeaturesFromLayer(layers, layerId)?.find((feature) => feature.id === featureId);
    return feature;
}
//# sourceMappingURL=getFeature.js.map